class global {
    formatParameter(object) {
        var encodedString = '';
        for (var prop in object) {
            if (object.hasOwnProperty(prop)) {
                if (encodedString.length > 0) {
                    encodedString += '&';
                }
                encodedString += encodeURI(prop + '=' + object[prop]);
            }
        }
        return encodedString;
    };

    formatParameterV2(object) {
        var encodedString = '';
        for (var prop in object) {
            if (object.hasOwnProperty(prop)) {
                if (encodedString.length > 0) {
                    encodedString += '&';
                }
                encodedString += prop + '=' + encodeURIComponent(object[prop]);
            }
        }
        return encodedString;
    };

    fetchCurrentDateNumber() {
        var date = new Date();
        var yyyy = date.getFullYear();
        var mm = String(date.getMonth() + 1).padStart(2, '0');
        var dd = String(date.getDate()).padStart(2, '0');
        var hours = String(date.getHours()).padStart(2, '0');
        var minutes = String(date.getMinutes()).padStart(2, '0');
        var seconds = String(date.getSeconds()).padStart(2, '0');
        return parseInt(yyyy + mm + dd + hours + minutes + seconds);
    };

    fetchCurrentDateStr(firstDayOfTheMonth) {
        var date = new Date();
        var yyyy = date.getFullYear();
        var mm = String(date.getMonth() + 1).padStart(2, '0');
        var dd = firstDayOfTheMonth === true ? '01' : String(date.getDate()).padStart(2, '0');
        return dd + '/' + mm + '/' + yyyy;
    };

    fetchCurrentYearStr(firstDayOfTheYear) {
        var date = new Date();
        var yyyy = date.getFullYear();
        var mm = firstDayOfTheYear ? '01' : String(date.getMonth() + 1).padStart(2, '0');
        var dd = firstDayOfTheYear ? '01' : String(date.getDate()).padStart(2, '0');
        return dd + '/' + mm + '/' + yyyy;
    }
    

    fetchCurrentDayStr1(day) {
        var date = new Date();
        var yyyy = date.getFullYear();
        var mm = String(date.getMonth() + 1).padStart(2, '0');
        var dd = String(date.getDate() + day).padStart(2, '0');
        return dd + '/' + mm + '/' + yyyy;
    };

    fetchCurrentMonthStr1(day, month) {
        var date = new Date();
        var yyyy = date.getFullYear();
        var mm = String((date.getMonth() + 1) + month).padStart(2, '0');
        var dd = String(date.getDate() + day).padStart(2, '0');
        return dd + '/' + mm + '/' + yyyy;
    };

    fetchCurrentYear(discountMonth) {
        var date = new Date();
        if (discountMonth === true) {
            date.setMonth(date.getMonth() - 3);
        }
        var yyyy = date.getFullYear();
        return parseInt(yyyy);
    };

    fetchCurrentMonth(discountMonth) {
        var date = new Date();
        if (discountMonth === true) {
            date.setMonth(date.getMonth() - 3);
        }
        var mm = String(date.getMonth() + 1).padStart(2, '0');
        return parseInt(mm);
    };

    fetchCurrentAnioMesStr() {
        var date = new Date();
        var yyyy = date.getFullYear();
        var mm = String(date.getMonth()+1 ).padStart(2, '0');
        return yyyy + '-' + mm ;
    };

    copyText(text) {
        var textArea = document.createElement("textarea");
        textArea.value = text;
        document.body.appendChild(textArea);
        textArea.select();
        document.execCommand("Copy");
        textArea.remove();
    }

    fetchUniqueCode() {
        return Math.random().toString(36).substr(2, 9);
    }

    dowloadFile(file, filename) {
        var link = document.createElement('a');
        document.body.appendChild(link);
        link.href = window.URL.createObjectURL(file);
        link.download = filename;
        link.click();
        document.body.removeChild(link);
    };

    downloadFileBlob(dataUrl, filename) {

        // Construct the 'a' element
        var link = document.createElement("a");
        link.download = filename;
        link.target = "_blank";

        // Construct the URI
        link.href = dataUrl;
        document.body.appendChild(link);
        link.click();

        // Cleanup the DOM
        document.body.removeChild(link);
        //delete link;
    }

    cleanInputFile(id, change) {
        document.getElementById(id).value = "";
        const fileinput = document.getElementById(id).cloneNode(true);
        document.getElementById(id).replaceWith(fileinput);
        document.getElementById(id).addEventListener('change', change);
    };

    formatSearch(value) {
        value = value.toLowerCase();
        value = value.replace(new RegExp('á', 'g'), 'a');
        value = value.replace(new RegExp('é', 'g'), 'e');
        value = value.replace(new RegExp('é', 'g'), 'i');
        value = value.replace(new RegExp('ó', 'g'), 'o');
        value = value.replace(new RegExp('ú', 'g'), 'u');
        return value;
    };

    groupBy(array, f) {
        var groups = {};
        array.forEach(function (o) {
            var group = JSON.stringify(f(o));
            groups[group] = groups[group] || [];
            groups[group].push(o);
        });
        return Object.keys(groups).map(function (group) {
            return groups[group];
        })
    };

    decimalFormat(value) {
        value += '';
        var x = value.split('.');
        var x1 = x[0];
        var x2 = x.length > 1 ? '.' + x[1] : '';
        var rgx = /(\d+)(\d{3})/;
        while (rgx.test(x1)) {
            x1 = x1.replace(rgx, '$1' + ',' + '$2');
        }
        return x1 + x2;
    };

    getAnios() {
        var anios = [];
        var anioInicial = 2015;
        var date = new Date();
        var anioActual = date.getFullYear();

        for (var anio = anioActual; anio >= anioInicial; anio--) {
            var objAnio = { id: anio, nombre: anio };
            anios.push(objAnio);
        }
        return anios;
    }

    onChangeDecimals = (e) => {
        if (e.target.value === '' || isNaN(parseFloat(e.target.value).toFixed(2)))
            e.target.value = '0.00';
        else
            e.target.value = parseFloat(e.target.value).toFixed(2);
    }

    onBlurDecimals = (e, decimals) => {
        if (e.target.value === '' || isNaN(parseFloat(e.target.value).toFixed(decimals)))
            return parseFloat(0).toFixed(decimals);
        else
            return parseFloat(e.target.value).toFixed(decimals);
    }

    onKeyPressDecimals = (e) => {
        const reg = /^-?[0-9]*(\.[0-9]*)?$/;
        const pressedKey = String.fromCharCode(!e.charCode ? e.which : e.charCode);
        if (!reg.test(pressedKey)) {
            e.preventDefault();
            return false;
        }
    }

    onKeyPressText = (e) => {
        const regUpper = /[A-Z]+/;
        const regLower = /[a-z]+/;
        const pressedKey = String.fromCharCode(!e.charCode ? e.which : e.charCode);
        if (regUpper.test(pressedKey) || regLower.test(pressedKey)) {
            return true;
        } else {
            e.preventDefault();
            return false;
        }
    }

    onKeyPressNumber = (e) => {
        const reg = /[0-9]+/;
        const pressedKey = String.fromCharCode(!e.charCode ? e.which : e.charCode);
        if (!reg.test(pressedKey)) {
            e.preventDefault();
            return false;
        }
    }

    onKeyPressCopy = (e) => {
        var theEvent = e || window.event;
        var key = theEvent.keyCode || theEvent.which;
        key = String.fromCharCode(key);
        var regex = /[a-zA-z]|\s/;
        if (!regex.test(key)) {
            e.preventDefault();
            return;
        }
    }


    onKeyPressTextNumber = (e) => {
        const regUpper = /[A-Z]+/;
        const regLower = /[a-z]+/;
        const regNumber = /[0-9]+/;
        const pressedKey = String.fromCharCode(!e.charCode ? e.which : e.charCode);
        if (regUpper.test(pressedKey) || regLower.test(pressedKey) || regNumber.test(pressedKey)) {
            return true;
        } else {
            e.preventDefault();
            return false;
        }
    }

    getDeviceType() {
        const ua = navigator.userAgent;
        if (/(tablet|ipad|playbook|silk)|(android(?!.*mobi))/i.test(ua)) {
            return "tablet";
        }
        if (/Mobile|iP(hone|od)|Android|BlackBerry|IEMobile|Kindle|Silk-Accelerated|(hpw|web)OS|Opera M(obi|ini)/.test(ua)) {
            return "mobile";
        }
        return "desktop";
    };
}
export default new global();